module.exports = __webpack_public_path__ + "img/rincian-2.54b11c76.png";